import React from 'react';

/**
 * Shared section header: eyebrow + heading (+ optional lead paragraph).
 * Replaces the copy-pasted eyebrow/heading blocks across landing sections.
 */
const SectionHeading = ({
  eyebrow,
  title,
  lead,
  id,
  as: Heading = 'h2',
  align = 'left',
  className = '',
  children,
}) => (
  <div className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-2xl ${className}`}>
    {eyebrow && (
      <p className="eyebrow">
        <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" />
        {eyebrow}
      </p>
    )}
    <Heading id={id} className="heading-xl mt-3">
      {title}
    </Heading>
    {lead && (
      <p className={`mt-5 text-base leading-7 text-text-secondary ${align === 'center' ? 'mx-auto' : ''}`}>
        {lead}
      </p>
    )}
    {children}
  </div>
);

export default SectionHeading;
